export default __webpack_public_path__ + "static/media/hellenic.4893a3e4.png";